import React, { useEffect, useState } from 'react';
import qrAdVideo from '../../../../assets/creative/AdInnovation_QR.mp4';
import qrAdVideoVertical from '../../../../assets/creative/vertical_qr.mp4';
import qrPlaceholder from '../../../../assets/creative/QR.png';

const OVERLAY_POSITION_CLASS = {
    'Bottom Left': 'ia-qr-left',
    'Bottom Right': 'ia-qr-right',
};

// The <video> is a single persistent DOM node across every layout/position change —
// only the surrounding container sizes/positions change (via CSS transition), so
// playback never restarts and object-fit: contain keeps the source's own aspect
// ratio intact as it resizes.
const QrAdPreview = ({ layout, position, ctaText, isMobile, videoRef }) => {
    const overlayPosClass = OVERLAY_POSITION_CLASS[position] || 'ia-qr-left';
    const videoSrc = isMobile ? qrAdVideoVertical : qrAdVideo;

    // The layout actually being rendered lags behind the `layout` prop — both on
    // first load and every time layout/position changes, the video first shows
    // full-screen (revealedLayout: null, no panel shift, no QR) for 3s, then the
    // video shift AND the QR/panel reveal happen together, not the QR alone.
    const [revealedLayout, setRevealedLayout] = useState(null);
    const [isQrVisible, setIsQrVisible] = useState(false);

    useEffect(() => {
        setIsQrVisible(false);
        setRevealedLayout(null);
        const timer = setTimeout(() => {
            setRevealedLayout(layout);
            setIsQrVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, [layout, position]);

    const isSidePanel = revealedLayout === 'sidePanel';
    const isOverlay = revealedLayout === 'overlay';
    const panelSideClass = isSidePanel ? (position === 'Left' ? 'panel-left' : 'panel-right') : 'panel-none';

    return (
        <div className={`ia-video-frame ia-qr-frame ${panelSideClass}`}>
            <div className="ia-video-viewport">
                <video ref={videoRef} className="ia-ad-mock-media" src={videoSrc} autoPlay loop muted playsInline />
                <div
                    className={`ia-ad-mock-qr ia-overlay-decoration ${overlayPosClass} ${!isSidePanel && isOverlay && isQrVisible ? 'visible' : ''}`}
                >
                    <img src={qrPlaceholder} alt="QR code placeholder" className="ia-qr-image" />
                    <span>{ctaText || 'Scan Me'}</span>
                </div>
            </div>
            <div className="ia-qr-sidepanel">
                <div className={`ia-qr-sidepanel-inner ${isSidePanel && isQrVisible ? 'visible' : ''}`}>
                    <img src={qrPlaceholder} alt="QR code placeholder" className="ia-qr-image" />
                    <span>{ctaText || 'Scan Me'}</span>
                </div>
            </div>
        </div>
    );
};

export default QrAdPreview;
